import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import dayjs from 'dayjs';

import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../Store';

import ModalBox from '../Components/ModalBox.js';
import WinnersTable from '../Components/WinnersTable.js';

const DrawingTable = ({ promotionId, user, drawings, actions, loading, loginLink = false, excludes = [] }) => {
    const [selectedDrawing, setSelectedDrawing] = useState(null);
    const [activeColumn, setActiveColumn] = useState(2);
    const [numberOfCols, setNumberOfCols] = useState(4);
    const [cols] = useState({
        drawNumber: 1,
        drawEnd: 2,
        drawDate: 3,
        entries: 4,
        prizes: 5,
    });

    useEffect(() => {
        // let colUpdate;
        let colsNum = excludes.includes('prizes') ? 3 : 4;
        if (user.loggedIn || loginLink) {
            // Show entries col if player is logged in or login link otherwise
            cols.entries = 4;
            cols.prizes = 5;
            colsNum = colsNum + 1;
        } else {
            // Player is not logged in so don't show entries col at all.
            cols.entries = 0;
            cols.prizes = 4;
        }

        setNumberOfCols(colsNum);
    }, [user.loggedIn, loginLink, excludes]);

    useEffect(async () => {
        if (drawings?.view.toLowerCase() === 'draft' || promotionId !== drawings?.promotionId || promotionId === 0) {
            await actions.drawingActions.getDrawings({ promotion_id: promotionId });
        }
    }, [promotionId, user.loggedIn]);

    const hideWinners = () => {
        setSelectedDrawing(null);
    };

    const viewWinners = (e) => {
        const drawing = drawings?.drawings.filter((drawing) => drawing.draw_date == e.target.dataset.date)[0];
        setSelectedDrawing(drawing);
    };

    const nextColumn = () => {
        setActiveColumn((activeColumn) => activeColumn + 1);
    };

    const previousColumn = () => {
        setActiveColumn((activeColumn) => activeColumn - 1);
    };

    const displayDate = (date, withTime = false, timeZone = '') => {
        // TBD feature for future draw dates
        const isTBD = dayjs(date).diff(dayjs(), 'year') >= 5;
        if (isTBD) {
            return 'TBD';
        }

        if (withTime) {
            // example: Tuesday, June 8, 2021
            return (
                <>
                    <span className={withTime ? 'd-block' : ''}>{`${dayjs(date).format('dddd')}, ${dayjs(date).format('MMMM D, YYYY')}, `}</span>
                    <span>{`${dayjs(date).format('hh:mm:ss A')} ${timeZone}`}</span>
                </>
            );
        } else {
            return (
                <>
                    <span>{`${dayjs(date).format('dddd')}, `}</span>
                    <span>{`${dayjs(date).format('MMMM D, YYYY')} `}</span>
                </>
            );
            // example: Tuesday, June 8, 2021
        }
    };

    const winnersLink = (winners, drawDate) => {
        return winners && winners.length ? (
            <span>
                <a href='#' data-date={drawDate} onClick={viewWinners}>
                    Click here
                </a>{' '}
                to view <br />
                Drawing Winners
            </span>
        ) : null;
    };

    const displayPrize = (prizes) => (
        <>
            {prizes?.map((prize, idx) => (
                <span key={idx} dangerouslySetInnerHTML={{ __html: prize }} />
            ))}
        </>
    );

    const showEntries = (drawStartDate, entries) => {
        // if drawing start date not started yet, then return '-';
        const drawDate = dayjs(drawStartDate);
        const dateDiff = dayjs().diff(drawDate, 'day');
        if (dateDiff < 0) {
            // future draws
            entries = '-';
        }

        const loginLink = (
            <span>
                <Link to='/login'>LOGIN</Link> TO VIEW
                <br />
                ENTRIES
            </span>
        );

        return user.loggedIn ? entries : loginLink;
    };

    const drawingsData = (drawings) => {
        return (
            <>
                {drawings?.map((drawing, index) => {
                    return (
                        <tr key={index}>
                            <td data-title='Drawing' className='td-draw-number first-col'>
                                {drawing.category === '1' ? drawing?.draw_number : 'Final'}
                            </td>
                            <td data-title='Entry Deadline' className={`td-entry-end other-col ${activeColumn == cols.drawEnd ? 'show' : ''}`}>
                                {displayDate(drawing?.draw_end, true, 'Central')}
                            </td>
                            <td data-title='Drawing Date' className={`td-draw-date other-col ${activeColumn == cols.drawDate ? 'show' : ''}`}>
                                {displayDate(drawing?.draw_date)}
                            </td>
                            {(user.loggedIn || loginLink) && (
                                <td className={`td-entries other-col ${activeColumn == cols.entries ? 'show' : ''}`}>
                                    {showEntries(drawing?.draw_start, drawing?.total_entries)}
                                </td>
                            )}
                            {!excludes.includes('prizes') && (
                                <td data-title='Prizes' className={`td-prize other-col ${activeColumn == cols.prizes ? 'show' : ''}`}>
                                    {winnersLink(drawing?.winners, drawing?.draw_date)}
                                    {displayPrize(drawing?.prizes)}
                                </td>
                            )}
                        </tr>
                    );
                })}
            </>
        );
    };

    return (
        <div className='table-scroll-container'>
            <button id='prevColumn' className='shift lft' disabled={activeColumn <= 2} onClick={previousColumn}>
                &lt;
            </button>
            <button id='nextColumn' className='shift rgt' disabled={activeColumn >= numberOfCols} onClick={nextColumn}>
                &gt;
            </button>
            <table id='drawing-table' className='table-panelled drawings-table'>
                <thead>
                    <tr>
                        <th className='td-draw-number first-col'>Drawing</th>
                        <th className={`td-entry-end other-col ${activeColumn == cols.drawEnd ? 'show' : ''}`}>
                            Entry
                            <br />
                            Deadline
                        </th>
                        <th className={`td-draw-date other-col ${activeColumn == cols.drawDate ? 'show' : ''}`}>
                            Drawing
                            <br />
                            Date
                        </th>
                        {(user.loggedIn || loginLink) && <th className={`td-entries other-col ${activeColumn == cols.entries ? 'show' : ''}`}>Entries</th>}
                        {!excludes.includes('prizes') && <th className={`td-prize other-col ${activeColumn == cols.prizes ? 'show' : ''}`}>Prizes</th>}
                    </tr>
                </thead>
                <tbody>
                    {loading.actions['getDrawings'] ? (
                        <tr>
                            <td colSpan={numberOfCols}>
                                <div className='loading-icon ellipses' />
                            </td>
                        </tr>
                    ) : (
                        drawingsData(drawings?.drawings)
                    )}
                </tbody>
            </table>
            {selectedDrawing && (
                <ModalBox closeCallback={hideWinners}>
                    <WinnersTable drawing={selectedDrawing} />
                </ModalBox>
            )}
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawingTable);
